import {CatalogProduct, CatalogProductMediaContent, ProductCardVm, ProductVm} from "@lib/Catalog/CatalogModels";
import {assetFullPath} from "@commons/Utils";
import {buildRoute} from "@router/RouterUtils";
import {AppRoute} from "@router/RoutingModels";

export function getProductImage(mediaList: CatalogProductMediaContent[], type: "default" | "preview") {

    if ( !mediaList || mediaList.length === 0 ) return "";

    if ( type === "preview" ) {
        return mediaList?.find(m => m.flPreview)?.mediaUrl ??
            mediaList?.find(m => m.flDefault)?.mediaUrl ??
            mediaList?.[0]?.mediaUrl ??
            "";
    }

    return mediaList?.find(m => m.flDefault)?.mediaUrl ??
        mediaList?.find(m => m.flPreview)?.mediaUrl ??
        mediaList?.[0]?.mediaUrl ??
        "";

}

export function mapCatalogProductToCard(p: CatalogProduct): ProductCardVm {
    const productLogicId = p.logicId;

    const pointsRaw = (p as CatalogProduct).redemptionModalities?.[0]?.finalPointsPrice;
    const points = Number.isFinite(pointsRaw) ? (pointsRaw as number) : 0;

    const mediaUrl = getProductImage(p.mediaContents, "preview");

    const image = assetFullPath(mediaUrl);

    const brand = p.brands?.[0]?.title?.trim() ?? "";
    const brandLogo = p.brands?.[0]?.brandLogo ?? null;

    const category = (p.sectors ?? []).filter(s => s.title.toLowerCase() !== "root")?.[0]?.title?.trim() ?? "";

    const now = new Date();

    const purchasable =
        Boolean(p.purchaseEnabled)
        && p.redemptionModalities?.length > 0 && !!p.redemptionModalities[0].finalPointsPrice &&
        (!!p.redemptionBeginTimestamp && new Date(p.redemptionBeginTimestamp) <= now) &&
        (!!p.redemptionEndTimestamp && new Date(p.redemptionEndTimestamp) >= now);

    return {
        productLogicId,
        purchasable,

        image,
        title: p.title ?? "",
        points,

        brand,
        brandLogo,
        category,

        categoryName: category || null,

        linkProps: {to: buildRoute(AppRoute.PRODUCT, {productId: productLogicId})},
    };
}

export function mapCatalogProductToProductPage(p: CatalogProduct): ProductVm {

    const partial = mapCatalogProductToCard(p);

    const mediaUrl = getProductImage(p.mediaContents, "default");

    return {
        ...partial,
        redemptionModalityId: p.redemptionModalities?.[0]?.logicId,
        productType: p.productType,
        image: mediaUrl,
        shortDescription: p.shortDescription ?? "",
        longDescription: p.longDescription ?? "",
        terms: p.termsAndConditions ?? "",
        brandDescription: p.brands?.[0]?.description?.trim() ?? ""
    };
}